import React, { useMemo } from 'react';
import { TASK_PRIORITIES, TASK_STATUSES } from '../constants';
import UserCheckmark from '../../../../common/user-checkmark/user-checkmark';
import IconButton from '../../../../common/icon-button/icon-button';
import Select from 'react-select';
/* Styles */
import './task-list-item-details.scss';
import { getFormattedDate, ONE_DAY } from '../../../../../helpers/dateTime';

const getPillStyle = ({ color }) => ({
    backgroundColor: color
});

// TODO move customStyles to other file after widget is implemented if possible
const customStyles = {
    placeholder: (defaultStyles) => {
        return {
            ...defaultStyles,
            color: '#ffffff'
        };
    },
    control: (provided, state) => {
        return {
            ...provided,
            backgroundColor: state.getValue()[0].color,
            borderStyle: 'none',
            borderWidth: 0,
            width: 220
        };
    },
    option: (provided) => ({
        ...provided,
        width: 220
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#ffffff'
    }),
    menu: (provided) => ({
        ...provided,
        width: 220
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none'
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#ffffff'
    })
};

const TaskListItemDetails = ({
    task: {
        name,
        description,
        priority,
        status,
        createdUserFirstName,
        createdUserLastName,
        createdUserId,
        assignedUserFirstName,
        assignedUserLastName,
        assignedUserId,
        targetDate
    },
    createdOn,
    closeDetails,
    onStatusChange,
    onEditClick,
    onDeleteClick,
    isEditAllowed
}) => {
    const taskPriority = useMemo(() => TASK_PRIORITIES.find(({ value }) => value === priority), [priority]);
    const taskStatus = useMemo(() => TASK_STATUSES.find(({ value }) => value === status), [status]);
    const isNewTask = useMemo(() => Date.now() - createdOn < ONE_DAY, [createdOn]);

    return (
        <div className="glu-modal-content glu-task-list-item-details">
            <div className="glu-modal__header">
                <div
                    className="glu-task-priority glu-pill"
                    style={getPillStyle(taskPriority)}
                >
                    {taskPriority.label}
                </div>
                {isNewTask && <div className="glu-task-new-pill glu-pill">New</div>}
                <div className="glu-modal__title glu-flex-grow glu-task-list__title text-ellipsis">
                    {name}
                </div>
                <div className="glu-flex-shrink glu-flex glu-flex-row">
                    {!isEditAllowed && (
                        <div className="edit-delete-action glu-flex glu-flex-row">
                            <IconButton
                                onClick={onEditClick}
                                icon="edit"
                            />
                            <IconButton
                                onClick={onDeleteClick}
                                icon="delete"
                            />
                        </div>
                    )}
                    <IconButton
                        onClick={closeDetails}
                        icon="close"
                    />
                </div>
            </div>
            <div className="glu-modal__body">
                <div className="glu-content__section glu-task-list-item-details__text">
                    <div className="glu-flex glu-flex-align-center glu-task-list-item-details__assigned-to">
                        <UserCheckmark
                            label="Assigned to: "
                            ownerId={assignedUserId}
                            userLabel={`${assignedUserFirstName} ${assignedUserLastName}`}
                        />
                    </div>
                    <div className="glu-flex glu-flex-align-center glu-task-list-item-details__assigned-to">
                        <UserCheckmark
                            label="Creator: "
                            ownerId={createdUserId}
                            userLabel={`${createdUserFirstName} ${createdUserLastName}`}
                        />
                    </div>
                    {targetDate && <p>{`Target date: ${getFormattedDate(targetDate)}`}</p> }
                </div>
                {description && (
                    <div className="glu-content__section glu-task-list-item-details__text">
                        <div className="glu-label">Description</div>
                        <pre className="glu-content-pre glu-task-list-item-details__description">
                            {description}
                        </pre>
                    </div>
                )}
                <div className="glu-content__section">
                    <div className="glu-label">Status</div>
                    <Select
                        options={TASK_STATUSES}
                        className="glu-select glu-form-input-pad"
                        styles={customStyles}
                        value={taskStatus}
                        onChange={onStatusChange}
                        aria-label="status-select"
                    />
                </div>
            </div>
        </div>
    );
};

export default TaskListItemDetails;
